import { Box, Divider, Typography } from "@mui/material";
import { SolutionFeature } from "../../models/schema";
import { colors } from "../../theme/colors";
import RenderContent from "../utils/RenderContent";

export const SolutionFeatureCard = ({ solutionFeature }: { solutionFeature: SolutionFeature }) => {
  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <Box
        sx={{
          position: "relative",
          p: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: `1px ${colors.grey2} solid`,
          boxSizing: "border-box",
          height: "100%",
          backgroundColor: colors.white,
          zIndex: 1
        }}>
        <Typography variant="h5" mb={2} sx={{ wordBreak: "break-word" }}>
          {solutionFeature.title}
        </Typography>
        <Divider sx={{ width: "100%", mt: 3, mb: 6, borderTop: `1px ${colors.grey1} solid` }} />
        <RenderContent content={solutionFeature.description?.json} />
      </Box>
    </Box>
  );
};
